import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
// import NotificationProvider from "./components/NotificationProvider";
// import "devextreme/dist/css/dx.light.css";

import { Provider, useDispatch } from "react-redux";
import { store } from "./store";

const element = document.getElementById("root");

const root = createRoot(element);

root.render(
  <Provider store={store}>
    {/* <NotificationProvider> */}
    <App />
    {/* </NotificationProvider> */}
  </Provider>
);
